/**
 * Area Listings Page View - Router
 * 
 * Routes to legacy or v2 layout.
 * V2 is currently disabled (isLayoutV2 = false) to prevent production rollout.
 * This is the entry point for the area listings page view.
 */

import { AreaListingsPageLegacy } from './legacy';
import { AreaListingsPageV2 } from './v2';
import type { AreaListingsPageLegacyProps } from './legacy';

// Re-export types for backwards compatibility
export type {
  Pagination,
  AreaInsightsData,
  LocalizedHeadingData,
  LocalizedSubheadingData,
} from './legacy';

// Use legacy props as the main props type for backwards compatibility
export type AreaListingsPageProps = AreaListingsPageLegacyProps;

const AreaListingsPageView = (props: AreaListingsPageProps) => {
  // V2 layout disabled - set to true when ready for production rollout
  const { useLayoutV2 } = props;

  if (useLayoutV2) {
    return <AreaListingsPageV2 {...props} />;
  }

  return <AreaListingsPageLegacy {...props} />;
};

export default AreaListingsPageView;
